import {
  all,
  // call,
  // put,
  // takeLatest
} from 'redux-saga/effects';
// import Actions from '../actions';
// import axios from 'axios';
// import get from 'lodash.get';
// import { api } from 'services';




export default function* systemSaga() {
  yield all([])
}